import type { Interpolation } from "@emotion/react";

export const stylesScreenReader: Interpolation = {
  border: "0 !important",
  clip: "rect(1px, 1px, 1px, 1px) !important",
  clipPath: "inset(50%) !important",
  height: "1px !important",
  margin: "-1px !important",
  overflow: "hidden !important",
  padding: "0 !important",
  position: "absolute !important" as "absolute",
  whiteSpace: "nowrap !important",
  width: "1px !important",
};
